import { render, staticRenderFns } from "./SizeSetter.vue?vue&type=template&id=25ee2ba9&scoped=true&"
import script from "./SizeSetter.vue?vue&type=script&lang=js&"
export * from "./SizeSetter.vue?vue&type=script&lang=js&"
import style0 from "./SizeSetter.vue?vue&type=style&index=0&id=25ee2ba9&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25ee2ba9",
  null
  
)

component.options.__file = "SizeSetter.vue"
export default component.exports